import { render, staticRenderFns } from "./EditFaculty.vue?vue&type=template&id=1cfd241c&scoped=true&lang=true&"
import script from "./EditFaculty.vue?vue&type=script&lang=js&"
export * from "./EditFaculty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfd241c",
  null
  
)

export default component.exports